import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/common/modal'
import StandardError from 'components/common/standard_error'
import { connect } from 'react-redux'
import { getI18n } from 'client/i18n'
import { exitGlimpse } from 'lib/glimpse'
import { routerShape } from 'react-router/lib/PropTypes'

const i18n = getI18n('components/pages/create/create')

class CountryBlocked extends React.Component {
  static propTypes = {
    countryName: PropTypes.string,
    showClose: PropTypes.bool,
    router: routerShape.isRequired,
  }

  static defaultProps = {
    showClose: false,
  }

  handleClose = () => {
    exitGlimpse('send', this.props.router)
  }

  render() {
    return (
      <Modal
        glimpse={true}
        onClose={this.handleClose}
        showClose={this.props.showClose}
      >
        <StandardError
          iconType="warning"
          title={i18n('blocked_title')}
          subtitle={i18n('blocked_subtitle', {
            country: this.props.countryName,
          })}
          showButton={false}
        />
      </Modal>
    )
  }
}

export default connect(state => {
  return {
    countryName: state.country.country_name,
  }
})(CountryBlocked)
